import * as React from 'react';

const Address = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    {...props}
  >
    <mask
      id='mask0_1209_3895'
      maskUnits='userSpaceOnUse'
      x='0'
      y='0'
      width='20'
      height='20'
    >
      <path d='M20 0H0V20H20V0Z' fill='white' />
    </mask>
    <g mask='url(#mask0_1209_3895)'>
      <path
        d='M14.8479 3.12986C13.5889 1.91736 11.8667 1.25 10 1.25C8.13333 1.25 6.41111 1.91806 5.15208 3.12986C3.84514 4.38819 3.125 6.16458 3.125 8.13125C3.125 10.6792 4.23542 13.25 6.33681 15.5653C7.89028 17.2771 9.4375 18.2535 9.50278 18.2944L10 18.6056L10.4972 18.2944C10.5625 18.2535 12.109 17.2771 13.6632 15.5653C15.7646 13.25 16.875 10.6799 16.875 8.13125C16.875 6.16458 16.1549 4.38819 14.8479 3.12986ZM12.3069 14.2694C11.4264 15.2458 10.5347 15.9639 10 16.3583C9.46528 15.9639 8.57292 15.2458 7.69306 14.2694C5.90625 12.2875 5 10.2222 5 8.13194C5 6.65833 5.50208 5.39583 6.45208 4.48125C7.36042 3.60694 8.62014 3.12569 10 3.12569C11.3799 3.12569 12.6396 3.60694 13.5479 4.48125C14.4979 5.39583 15 6.65833 15 8.13194C15 10.2229 14.0938 12.2875 12.3069 14.2694Z'
        fill='#200000'
      />
      <path
        d='M10 4.38184C8.10486 4.38184 6.5625 5.9242 6.5625 7.81934C6.5625 9.71447 8.10486 11.2568 10 11.2568C11.8951 11.2568 13.4375 9.71447 13.4375 7.81934C13.4375 5.9242 11.8951 4.38184 10 4.38184ZM10 9.38184C9.13819 9.38184 8.4375 8.68114 8.4375 7.81934C8.4375 6.95753 9.13819 6.25684 10 6.25684C10.8618 6.25684 11.5625 6.95753 11.5625 7.81934C11.5625 8.68114 10.8618 9.38184 10 9.38184Z'
        fill='#200000'
      />
    </g>
  </svg>
);

export default Address;
